import { useState } from 'react';

const TourTypesSection = () => {
  const [showAll, setShowAll] = useState(false);

  const tourTypes = [
    {
      id: 1,
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 40L16 32L24 36L32 28L40 32L48 24L56 28" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 48L20 44L28 46L36 42L44 44L52 40" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="32" cy="20" r="3" fill="#1E88E5"/>
          <path d="M32 23V28" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round"/>
          <path d="M28 30L32 28L36 30" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <rect x="20" y="50" width="4" height="8" rx="1" fill="#1E88E5"/>
          <rect x="40" y="50" width="4" height="8" rx="1" fill="#1E88E5"/>
          <path d="M16 58H48" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Лыжные туры',
      description: 'Горнолыжные курорты и фрирайд в лучших локациях для зимнего отдыха'
    },
    {
      id: 2,
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="24" r="6" stroke="#1E88E5" strokeWidth="2.5" fill="none"/>
          <circle cx="44" cy="24" r="6" stroke="#1E88E5" strokeWidth="2.5" fill="none"/>
          <path d="M26 24H38" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round"/>
          <path d="M32 24V36" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round"/>
          <path d="M20 30L16 40L20 42" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M44 30L48 40L44 42" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M28 36L24 48L28 52" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M36 36L40 48L36 52" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <rect x="8" y="38" width="12" height="8" rx="2" stroke="#1E88E5" strokeWidth="2" fill="none"/>
          <rect x="44" y="38" width="12" height="8" rx="2" stroke="#1E88E5" strokeWidth="2" fill="none"/>
          <path d="M12 14L16 10L20 14" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Велотур с автоподдержкой',
      description: 'Комфортные велопутешествия с сопровождением и перевозкой багажа'
    },
    {
      id: 3,
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="16" r="5" stroke="#1E88E5" strokeWidth="2.5" fill="none"/>
          <path d="M32 21V32" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round"/>
          <path d="M24 28L32 32L40 28" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M28 32L24 44L20 48" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M36 32L40 44L44 48" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 52L24 48L28 52" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M48 52L40 48L36 52" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 36L16 28L24 32" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M56 36L48 28L40 32" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="32" cy="32" r="2" fill="#1E88E5"/>
        </svg>
      ),
      title: 'Пешие',
      description: 'Треккинги и походы по живописным маршрутам с опытными проводниками'
    },
    {
      id: 4,
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 36C8 36 12 32 20 32C28 32 32 36 40 36C48 36 52 32 56 32" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round"/>
          <path d="M8 44C8 44 12 40 20 40C28 40 32 44 40 44C48 44 52 40 56 40" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round"/>
          <path d="M12 20L20 12L28 20L32 16L36 20L44 12L52 20" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <path d="M16 24L24 28L32 24L40 28L48 24" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="32" cy="20" r="3" fill="#1E88E5"/>
          <path d="M28 52L32 48L36 52" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M20 54L24 50L28 54" stroke="#1E88E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M36 54L40 50L44 54" stroke="#1E88E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'На воде',
      description: 'Сплавы, каякинг и морские экспедиции для любителей водных приключений'
    },
    {
      id: 5,
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32 8L48 28L56 24L44 40L52 44L32 56L12 44L20 40L8 24L16 28L32 8Z" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <path d="M24 32L32 28L40 32" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="32" cy="20" r="2" fill="#1E88E5"/>
          <path d="M28 36L32 40L36 36" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M20 44L24 48L28 44" stroke="#1E88E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M36 44L40 48L44 44" stroke="#1E88E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'В горы',
      description: 'Восхождения и горные походы разной сложности с профессиональными гидами'
    },
    {
      id: 6,
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="18" r="5" stroke="#1E88E5" strokeWidth="2.5" fill="none"/>
          <path d="M32 23V30" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round"/>
          <path d="M24 28L32 30L40 28" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M28 30L26 40L22 44" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M36 30L38 40L42 44" stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <ellipse cx="32" cy="50" rx="20" ry="6" stroke="#1E88E5" strokeWidth="2" fill="none"/>
          <path d="M16 12C16 12 20 8 24 10C28 12 28 16 32 16C36 16 36 12 40 10C44 8 48 12 48 12" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round"/>
          <path d="M20 20L24 16L28 20" stroke="#1E88E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M36 20L40 16L44 20" stroke="#1E88E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Прогулки',
      description: 'Легкие маршруты и экскурсионные туры для комфортного знакомства с природой'
    }
  ];

  const displayedTours = showAll ? tourTypes : tourTypes.slice(0, 3);

  return (
    <div className="bg-white py-20">
      <div className="max-w-[1360px] mx-auto px-6">
        <h2 className="font-mulish font-bold text-3xl text-gray-900 mb-12">
          Типы туров
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
          {displayedTours.map((tour) => (
            <div
              key={tour.id}
              className="bg-white rounded-lg p-8 border border-gray-200 hover:border-gray-300 transition-all duration-300 group cursor-pointer"
              style={{
                transition: 'background-color 0.3s ease, border-color 0.3s ease, transform 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f8ff70';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                {tour.icon}
              </div>
              <h3 className="font-mulish font-bold text-xl text-gray-900 mb-3">
                {tour.title}
              </h3>
              <p className="font-open-sans text-sm text-gray-600 leading-relaxed">
                {tour.description}
              </p>
            </div>
          ))}
        </div>

        {!showAll && (
          <div className="flex justify-center">
            <button
              onClick={() => setShowAll(true)}
              className="font-open-sans text-sm font-semibold text-white bg-[#1E88E5] hover:bg-[#0D47A1] px-8 py-3 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Показать еще
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TourTypesSection;
